var _metadata, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAileronBoldWebfont(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null)), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "aileronbold",
    horizAdvX: 1280
  }, /*#__PURE__*/React.createElement("fontFace", {
    unitsPerEm: 2048,
    ascent: 1577,
    descent: -471
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 397
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\uFB01",
    horizAdvX: 1230,
    d: "M41 895v186h117v19q0 86 4 123q14 159 129.5 240t367.5 81q72 0 158 -14v-197q-202 13 -283 -16.5t-90 -114.5q-4 -29 -4 -96v-25h658v-1081h-281v895h-377v-895h-282v895h-117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\uFB02",
    horizAdvX: 1230,
    d: "M41 895v186h96v19q0 75 4 112q29 332 512 332q256 0 410 -53v-1135q0 -71 4 -100q4 -51 31.5 -67.5t93.5 -10.5v-182q-74 -10 -184 -10q-213 0 -224 192q-2 49 -2 172v981q-51 15 -133 15q-209 0 -225 -144q-4 -29 -4 -96v-25h223v-186h-223v-895h-283v895h-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    horizAdvX: 682
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: " ",
    horizAdvX: 397
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\t",
    horizAdvX: 397
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA0",
    horizAdvX: 397
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "!",
    horizAdvX: 538,
    d: "M109 131q0 70 45 115t114 45q71 0 116.5 -45t45.5 -115t-45.5 -115t-116.5 -45q-69 0 -114 45t-45 115zM131 1413h277l-25 -1010h-227z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\"",
    horizAdvX: 774,
    d: "M113 1505h252l-29 -563h-197zM455 1505h252l-27 -563h-199z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "#",
    d: "M145 428v160h209l52 237h-199v160h231l92 428h170l-92 -428h180l93 428h170l-93 -428h179v-160h-211l-52 -237h201v-160h-233l-92 -428h-170l92 428h-180l-93 -428h-170l93 428h-177zM524 588h181l51 237h-181z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "$",
    d: "M96 397h277q13 -87 63.5 -141.5t130.5 -73.5v416q-103 33 -176 69.5t-129 87t-83 117t-27 152.5q0 92 33 166.5t90.5 124.5t131 81t160.5 42v159h168v-159q198 -19 308 -132t131 -288h-277q-20 172 -162 213v-395q239 -75 343 -181t104 -276q0 -172 -124 -278.5 t-323 -125.5v-159h-168v159q-208 18 -332 124t-139 298zM420 1057q0 -74 35.5 -117t111.5 -72v365q-69 -15 -108 -60t-39 -116zM735 178q168 25 168 180q0 70 -38 119.5t-130 83.5v-383z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "%",
    horizAdvX: 1562,
    d: "M74 1102q0 158 84 247t231 89q148 0 233 -89t85 -247t-85 -248t-233 -90q-147 0 -231 90t-84 248zM219 0l918 1413h219l-918 -1413h-219zM272 1102q0 -91 30 -140t87 -49t88 49t31 140q0 90 -31 138t-88 48t-87 -47.5t-30 -138.5zM856 309q0 157 85.5 246.5t232.5 89.5 q148 0 232.5 -89t84.5 -247t-84.5 -248t-232.5 -90q-147 0 -232.5 90t-85.5 248zM1057 309q0 -91 30 -139.5t87 -48.5t86.5 48.5t29.5 139.5t-29.5 139t-86.5 48t-87 -48t-30 -139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "&",
    horizAdvX: 1378,
    d: "M109 360q0 141 90 237t245 126q-119 31 -190.5 115.5t-71.5 199.5q0 190 141.5 297t387.5 107q124 0 223 -21v-209q-114 19 -221 19q-113 0 -172.5 -51t-59.5 -148q0 -192 203 -203q37 -2 121 -2h74v191h282v-191h193v-221h-193v-586q-235 -49 -481 -49 q-103 0 -186.5 11.5t-156.5 39.5t-122.5 72t-77.5 111t-28 155zM410 397q0 -117 67.5 -166t208.5 -49q103 0 193 17v407h-93q-73 0 -114 -4q-132 -9 -197 -62.5t-65 -142.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "'",
    horizAdvX: 409,
    d: "M72 1505h252l-27 -563h-197z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "(",
    horizAdvX: 743,
    d: "M225 717q0 530 289 880h154q-262 -401 -262 -880q0 -480 262 -881h-154q-140 169 -214.5 393t-74.5 488z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ")",
    horizAdvX: 741,
    d: "M68 -164q262 401 262 881q0 479 -262 880h153q289 -350 289 -880q0 -264 -74.5 -488t-214.5 -393h-153z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "*",
    horizAdvX: 1226,
    d: "M205 584l57 180l283 -119l-27 328h189l-25 -328l281 119l57 -180l-297 -70l217 -254l-152 -110l-176 282l-174 -282l-151 110l215 254z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "+",
    d: "M193 571v152h364v412h166v-412h364v-152h-364v-407h-166v407h-364z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ",",
    horizAdvX: 501,
    d: "M-57 -250l161 537h275v-21l-207 -516h-229z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "-",
    horizAdvX: 606,
    d: "M66 500v159h475v-159h-475z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ".",
    horizAdvX: 501,
    d: "M80 143q0 75 47.5 123.5t122.5 48.5q76 0 124 -48.5t48 -123.5t-48 -123.5t-124 -48.5q-75 0 -122.5 48.5t-47.5 123.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "/",
    horizAdvX: 669,
    d: "M-10 -61l514 1536h176l-514 -1536h-176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 0,
    d: "M90 707q0 735 551 735q549 0 549 -735q0 -736 -549 -736q-551 0 -551 736zM389 707q0 -268 61 -396.5t191 -128.5q129 0 189.5 128.5t60.5 396.5q0 270 -60.5 397t-189.5 127q-130 0 -191 -127t-61 -397z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 1,
    d: "M252 889v266l328 195q111 63 227 63h139v-1413h-282v1116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 2,
    d: "M121 0v133l475 465q149 146 207.5 235.5t58.5 186.5q0 96 -53.5 154.5t-149.5 58.5q-104 0 -158.5 -64t-68.5 -194l-2 -21h-280l2 21q22 227 159 348t375 121q228 0 351.5 -111t123.5 -297q0 -131 -74 -247t-272 -310l-262 -256h598v-223h-1030z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 3,
    d: "M78 434h282l5 -20q15 -108 85 -170t177 -62q113 0 181.5 59t68.5 156q0 106 -71.5 162t-209.5 59h-47v197l47 2q113 5 180.5 64.5t67.5 158.5q0 87 -54 139t-147 52t-150.5 -60.5t-68.5 -162.5l-2 -21h-281l2 21q20 194 156.5 314t374.5 120q223 0 346 -103.5t123 -265.5 q0 -123 -67.5 -207t-194.5 -118q295 -67 295 -340q0 -197 -153 -317t-394 -120q-242 0 -384 112.5t-165 330.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 4,
    d: "M74 334v151l661 928h301v-856h174v-223h-174v-334h-282v334h-680zM383 557h371v537q-51 -88 -95 -150z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 5,
    d: "M117 408h282l2 -21q16 -97 73 -151t155 -54q117 0 183.5 75.5t66.5 201.5t-65 202t-179 76q-84 0 -140 -37.5t-92 -121.5h-262l101 835h880v-221h-649l-53 -395l69 96q93 55 222 55q221 0 345 -129t124 -350q0 -118 -45 -214t-120.5 -157t-171 -94t-200.5 -33 q-482 0 -524 416z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 6,
    d: "M100 662q0 192 44 342t123 245t184.5 144t232.5 49q208 0 332.5 -106t146.5 -292l2 -20h-286l-5 20q-23 96 -73.5 141.5t-134.5 45.5q-258 0 -275 -492l72 129q102 82 252 82q223 0 344 -129.5t121 -333.5q0 -159 -74 -278t-195 -178.5t-268 -59.5q-270 0 -406.5 168.5 t-136.5 522.5zM403 461q0 -123 65 -201t173 -78t174 77t66 194q0 129 -62 207.5t-180 78.5q-100 0 -168 -74t-68 -204z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 7,
    d: "M111 1192v221h1081v-149l-678 -1264h-307l649 1192h-745z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 8,
    d: "M98 399q0 128 79 219.5t196 129.5q-96 36 -152.5 112t-56.5 191q0 177 131.5 284t361.5 107q229 0 359.5 -107t130.5 -284q0 -115 -65.5 -191.5t-168.5 -111.5q115 -38 192 -129.5t77 -219.5q0 -112 -43.5 -197t-120 -134.5t-172 -74t-209.5 -24.5q-121 0 -217 24 t-169.5 74.5t-113 134.5t-39.5 197zM395 406q0 -104 64.5 -165t181.5 -61q122 0 183 59.5t61 163.5q0 103 -62.5 166.5t-183.5 63.5q-114 0 -179 -63t-65 -164zM457 1038q0 -92 50.5 -144t143.5 -52q95 0 150 52.5t55 143.5q0 87 -54 140t-149 53q-91 0 -143.5 -53.5 t-52.5 -139.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 9,
    d: "M100 926q0 159 74 278t195 178.5t268 59.5q270 0 406.5 -167.5t136.5 -522.5q0 -192 -43 -342t-121.5 -245.5t-184.5 -144.5t-235 -49q-212 0 -336 106t-143 292l-2 20h286l5 -20q20 -96 70.5 -141.5t137.5 -45.5q258 0 275 492l-72 -129q-102 -82 -252 -82 q-223 0 -344 129.5t-121 333.5zM401 961q0 -129 61.5 -208t178.5 -79q100 0 168 74t68 204q0 123 -65 201t-173 78t-173 -76.5t-65 -193.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ":",
    horizAdvX: 501,
    d: "M80 143q0 75 47.5 123.5t122.5 48.5q76 0 124 -48.5t48 -123.5t-48 -123.5t-124 -48.5q-75 0 -122.5 48.5t-47.5 123.5zM80 946q0 76 47.5 124t122.5 48q76 0 124 -48t48 -124q0 -75 -48 -122.5t-124 -47.5q-75 0 -122.5 47.5t-47.5 122.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ";",
    horizAdvX: 501,
    d: "M-57 -250l161 545h275v-33l-205 -512h-231zM80 946q0 76 47.5 124t122.5 48q76 0 124 -48t48 -124q0 -75 -48 -122.5t-124 -47.5q-75 0 -122.5 47.5t-47.5 122.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "<",
    d: "M215 434v217l901 385v-196l-721 -295l721 -297v-197z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "=",
    d: "M170 367v151h940v-151h-940zM170 776v152h940v-152h-940z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ">",
    d: "M141 51v195l721 297l-721 295v198l901 -385v-217z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "?",
    horizAdvX: 1124,
    d: "M66 989q6 210 142.5 331.5t364.5 121.5q220 0 343.5 -104t123.5 -281q0 -113 -51 -203t-164 -192q-87 -78 -119 -130t-38 -129h-244q6 106 37.5 175t109.5 155q96 107 133 171.5t37 133.5q0 92 -48 142.5t-138 50.5q-91 0 -144 -61.5t-59 -180.5h-286zM387 131 q0 70 45.5 115t114.5 45q71 0 116.5 -45t45.5 -115t-45.5 -115t-116.5 -45q-69 0 -114.5 45t-45.5 115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "@",
    horizAdvX: 1832,
    d: "M100 506q0 197 73 366.5t196 285t286.5 180.5t343.5 65q169 0 309 -55.5t232 -151.5t142.5 -223t50.5 -271q0 -117 -25 -211.5t-68 -158t-102.5 -106.5t-125 -62t-138.5 -19q-104 0 -171.5 45.5t-90.5 135.5l-56 -111q-84 -70 -190 -70q-55 0 -102.5 17t-89.5 54.5 t-66.5 105.5t-24.5 161q0 141 52 258t147.5 186.5t214.5 69.5q116 0 168 -59l27 -109l38 132h244l-94 -394q-25 -117 -25 -153q0 -107 82 -107q89 0 152 100t63 281q0 261 -153.5 407t-405.5 146q-107 0 -210 -30.5t-194 -92.5t-160.5 -147t-109.5 -203t-40 -252 q0 -283 161 -442.5t439 -159.5q130 0 256 37.5t225 109.5l63 -139q-131 -87 -277.5 -128.5t-285.5 -41.5q-113 0 -219.5 26.5t-205.5 86t-173 145.5t-118 214t-44 282zM756 504q0 -160 100 -160q57 0 97 47t59 119l24 117q21 87 -4 129.5t-82 42.5q-86 0 -140 -86t-54 -209z "
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "A",
    horizAdvX: 1384,
    d: "M31 0l510 1413h354l500 -1413h-308l-139 426h-475l-141 -426h-301zM545 649h332l-164 522z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "B",
    horizAdvX: 1345,
    d: "M182 0v1413h506q112 0 182 -8q170 -22 263.5 -115t93.5 -237q0 -215 -219 -291q272 -70 272 -340q0 -94 -33.5 -170.5t-90 -125.5t-123 -78t-140.5 -40q-72 -8 -197 -8h-514zM465 223h246q67 0 94 2q77 6 127.5 57.5t50.5 137.5q0 93 -49.5 140.5t-132.5 55.5 q-61 7 -101 7h-235v-400zM465 834h213q50 0 100 6q154 24 154 176q0 76 -43 118.5t-117 51.5q-50 6 -102 6h-205v-358z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "C",
    horizAdvX: 1470,
    d: "M104 698q0 170 52 311t143.5 235.5t217 146t271.5 51.5q276 0 432 -134t179 -354l2 -20h-283l-4 20q-27 134 -109.5 205.5t-220.5 71.5q-172 0 -276.5 -138.5t-104.5 -377.5q0 -256 104.5 -394.5t272.5 -138.5q134 0 216.5 75.5t111.5 211.5l4 20h281l-2 -20 q-24 -228 -189 -363t-434 -135q-196 0 -346 87t-234 252.5t-84 387.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "D",
    horizAdvX: 1497,
    d: "M182 0v1413h488q108 0 180 -8q126 -15 230 -62.5t183.5 -129t124 -206t44.5 -282.5t-45 -288t-125 -218.5t-186 -142t-230 -68.5q-72 -8 -180 -8h-484zM465 223h168q104 0 149 6q161 21 256 150t95 342q0 205 -92 323.5t-253 139.5q-63 8 -151 8h-172v-969z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "E",
    horizAdvX: 1261,
    d: "M182 0v1413h1000v-221h-717v-373h665v-223h-665v-373h737v-223h-1020z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "F",
    horizAdvX: 1214,
    d: "M182 0v1413h1000v-221h-717v-373h645v-223h-645v-596h-283z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "G",
    horizAdvX: 1509,
    d: "M104 698q0 170 53.5 311t147 235.5t221 146t275.5 51.5q276 0 431.5 -134t178.5 -354l2 -20h-283l-4 20q-56 277 -329 277q-175 0 -284.5 -139t-109.5 -377q0 -256 106.5 -394.5t278.5 -138.5q137 0 227.5 84.5t112.5 233.5h-299v221h570v-721h-228l-18 229l-63 -143 q-118 -115 -345 -115q-295 0 -468 195.5t-173 531.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "H",
    horizAdvX: 1540,
    d: "M182 0v1413h283v-608h661v608h281v-1413h-281v580h-661v-580h-283z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "I",
    horizAdvX: 598,
    d: "M182 0v1413h283v-1413h-283z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "J",
    horizAdvX: 1220,
    d: "M104 514h283l4 -72q7 -137 64 -198.5t161 -61.5q96 0 148 57.5t61 161.5q2 45 2 150v862h283v-833q0 -105 -6 -195q-11 -192 -136 -303t-368 -111q-240 0 -364 124t-130 347z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "K",
    horizAdvX: 1398,
    d: "M182 0v1413h283v-682l610 682h336l-625 -676l596 -737h-364l-436 571l-117 -127v-444h-283z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "L",
    horizAdvX: 1236,
    d: "M182 0v1413h283v-1177h737v-236h-1020z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "M",
    horizAdvX: 1837,
    d: "M182 0v1413h447l319 -1153l320 1153h438v-1413h-283v653q0 337 4 484q-61 -257 -131 -482l-198 -655h-307l-203 657q-75 249 -127 478q4 -147 4 -482v-653h-283z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "N",
    horizAdvX: 1556,
    d: "M182 0v1413h375l594 -1094q-10 190 -10 445v649h280l2 -1413h-387l-581 1073q10 -193 10 -434v-639h-283z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "O",
    horizAdvX: 1566,
    d: "M104 707q0 221 83 387t242 257t374 91q323 0 510.5 -200t187.5 -535q0 -334 -187.5 -535t-510.5 -201q-324 0 -511.5 200.5t-187.5 535.5zM399 707q0 -247 107.5 -386t296.5 -139q188 0 294.5 139t106.5 386q0 248 -106.5 386t-294.5 138q-190 0 -297 -138t-107 -386z "
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "P",
    horizAdvX: 1275,
    d: "M182 0v1413h490q118 0 205 -10q169 -20 274.5 -131t105.5 -299q0 -95 -30.5 -173t-83 -130.5t-120.5 -84.5t-146 -42q-96 -11 -205 -11h-207v-532h-283zM465 756h203q78 0 125 6q78 11 123 63t45 148t-45 148t-123 63q-47 6 -125 6h-203v-434z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Q",
    horizAdvX: 1566,
    d: "M104 707q0 336 187.5 536.5t511.5 200.5q323 0 510.5 -200.5t187.5 -536.5q0 -152 -56.5 -281.5t-164.5 -214.5q120 -28 244 -131l-142 -182q-98 62 -158.5 84t-125.5 22q-64 0 -150 -18q-68 -15 -145 -15q-324 0 -511.5 200.5t-187.5 535.5zM399 707q0 -247 107.5 -386 t296.5 -139q188 0 294.5 139t106.5 386q0 248 -106.5 386t-294.5 138q-190 0 -297 -138t-107 -386z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "R",
    horizAdvX: 1339,
    d: "M182 0v1413h516q118 0 205 -10q80 -10 145 -35.5t117 -69.5t80.5 -112.5t28.5 -157.5q0 -133 -73.5 -220.5t-203.5 -123.5q99 -38 147.5 -120t61.5 -208q14 -131 37.5 -214t65.5 -142h-310q-50 138 -69 315q-29 241 -191 252q-39 2 -110 2h-164v-569h-283zM465 780h194 q84 0 115 2q92 8 147.5 57t55.5 146t-48 143.5t-138 57.5q-49 6 -119 6h-207v-412z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "S",
    horizAdvX: 1245,
    d: "M86 418h289q23 -114 102.5 -175t190.5 -61q99 0 165 49t66 129q0 91 -64.5 146.5t-218.5 91.5q-92 22 -160.5 46.5t-129.5 60t-99 80t-60 105.5t-22 138q0 126 70.5 221.5t184.5 144t251 48.5q123 0 219 -33.5t158 -95t98 -140.5t48 -176h-289q-12 110 -74 172t-170 62 q-89 0 -144 -42.5t-55 -125.5q0 -90 66.5 -141t234.5 -91q232 -54 341.5 -162.5t109.5 -279.5q0 -129 -73 -225.5t-190 -144.5t-259 -48q-258 0 -412 114t-174 333z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "T",
    horizAdvX: 1275,
    d: "M47 1192v221h1241v-221h-479v-1192h-283v1192h-479z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "U",
    horizAdvX: 1437,
    d: "M164 575v838h280v-866q0 -64 5 -103q9 -124 85 -193t214 -69q137 0 212 69t84 193q5 39 5 103v866h280v-838q0 -99 -4 -165q-7 -92 -43 -169t-103 -138.5t-177.5 -96.5t-253.5 -35q-144 0 -254.5 35t-178.5 96.5t-104 138.5t-43 169q-4 66 -4 165z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "V",
    horizAdvX: 1409,
    d: "M66 1413h307l375 -1196l380 1196h302l-510 -1413h-355z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "W",
    horizAdvX: 2021,
    d: "M53 1413h305l238 -1196l250 1176h397l242 -1180l254 1200h291l-375 -1413h-375l-242 1176l-254 -1176h-376z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "X",
    horizAdvX: 1384,
    d: "M39 0l506 713l-471 700h327l316 -522l332 522h325l-493 -694l503 -719h-329l-348 535l-332 -535h-336z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Y",
    horizAdvX: 1282,
    d: "M33 1413h319l330 -616l319 616h312l-500 -866v-547h-281v547z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Z",
    horizAdvX: 1273,
    d: "M102 0v215l772 977h-714v221h1050v-219l-766 -971h777v-223h-1119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "[",
    horizAdvX: 745,
    d: "M213 -164v1761h459v-159h-293v-1442h293v-160h-459z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\\\\\\\",
    horizAdvX: 669,
    d: "M-10 1475h176l514 -1536h-176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "]",
    horizAdvX: 733,
    d: "M63 -4h291v1442h-291v159h457v-1761h-457v160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "^",
    d: "M190 440l353 822h192l352 -822h-188l-260 660l-260 -660h-189z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "_",
    horizAdvX: 1024,
    d: "M102 -18h820v-160h-820v160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "`",
    horizAdvX: 614,
    d: "M2 1419h254l158 -241h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "a",
    horizAdvX: 1150,
    d: "M68 289q0 181 153 278t447 97h69v22q0 65 -4 102q-6 61 -47.5 96.5t-120.5 35.5q-84 0 -130 -47.5t-52 -137.5l-274 -2q6 180 136 282.5t330 102.5q410 0 437 -321q6 -77 6 -168v-353q0 -125 20 -276h-276l-21 160l-53 -117q-107 -72 -270 -72q-148 0 -249 84.5 t-101 233.5zM360 311q0 -70 44.5 -105.5t121.5 -35.5q91 0 151 60.5t60 170.5v88q-40 3 -76 3q-68 0 -122 -10q-83 -15 -131 -58t-48 -113z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "b",
    horizAdvX: 1316,
    d: "M129 0v1505h283v-581l82 118q45 36 121 56t161 20q225 0 355.5 -153.5t130.5 -399.5q0 -143 -42 -258t-114.5 -187t-166 -110.5t-200.5 -38.5q-70 0 -143 17t-113 45l-71 112v-145h-283zM412 506q0 -89 23.5 -156.5t63.5 -105t86.5 -56t98.5 -18.5q128 0 206.5 97 t78.5 280q0 168 -75 270.5t-200 102.5q-127 0 -204.5 -87.5t-77.5 -275.5v-51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "c",
    horizAdvX: 1148,
    d: "M55 537q0 136 43 247.5t117.5 183.5t173 111t211.5 39q216 0 349.5 -118t148.5 -304h-279q-38 224 -225 224q-112 0 -179 -92.5t-67 -272.5q0 -194 66 -289.5t178 -95.5q84 0 142 53t79 154h283q-35 -197 -173.5 -301.5t-347.5 -104.5q-232 0 -376 146.5t-144 419.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "d",
    horizAdvX: 1320,
    d: "M55 524q0 144 42 259t114.5 187t166 110t200.5 38q71 0 143.5 -16.5t112.5 -44.5l71 -113v561h283v-1505h-283v168l-82 -121q-46 -35 -122 -55.5t-160 -20.5q-225 0 -355.5 153.5t-130.5 399.5zM348 543q0 -168 75 -270.5t200 -102.5q127 0 204.5 87t77.5 275v54 q0 88 -23.5 155t-63.5 105t-86.5 56t-98.5 18q-128 0 -206.5 -97t-78.5 -280z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "e",
    horizAdvX: 1183,
    d: "M55 541q0 253 152.5 415t400.5 162q122 0 220 -44t160.5 -120t96 -175t33.5 -212q0 -59 -4 -96h-774q24 -301 252 -301q92 0 153 48.5t74 135.5h283q-40 -186 -179 -284.5t-337 -98.5q-114 0 -209.5 36t-168 105t-113 179t-40.5 250zM348 655h479q-14 130 -72 197.5 t-159 67.5t-165.5 -66.5t-82.5 -198.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "f",
    horizAdvX: 692,
    d: "M41 895v186h117v45q0 88 4 125q25 293 395 293q60 0 125 -14v-197q-41 8 -77 8q-51 0 -89 -17q-65 -27 -72 -95q-4 -29 -4 -94v-54h224v-186h-224v-895h-282v895h-117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "g",
    horizAdvX: 1320,
    d: "M55 532q0 144 42 257.5t114.5 184.5t166 107.5t200.5 36.5q71 0 143.5 -16.5t112.5 -44.5l71 -113v146h283v-818q0 -152 -2 -211q-9 -249 -161 -376t-417 -127q-238 0 -370.5 95.5t-151.5 276.5l-2 21h274l2 -19q9 -75 76.5 -119t175.5 -44q132 0 208 66.5t83 195.5 q2 41 2 133v26l-82 -120q-99 -76 -270 -76q-228 0 -363 148t-135 390zM348 557q0 -167 74.5 -265.5t200.5 -98.5q127 0 204.5 87t77.5 275v31q0 88 -23.5 155t-63.5 105t-86.5 56t-98.5 18q-129 0 -207 -91.5t-78 -271.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "h",
    horizAdvX: 1271,
    d: "M129 0v1516h283v-603l84 129q108 76 262 76q171 0 270 -80t117 -225q8 -73 8 -199v-614h-283v575q0 97 -4 152q-6 90 -58 141.5t-151 51.5q-111 -2 -178 -104.5t-67 -317.5v-498h-283z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "i",
    horizAdvX: 544,
    d: "M115 1346q0 66 43 107.5t112 41.5t112.5 -41.5t43.5 -107.5q0 -67 -43.5 -108.5t-112.5 -41.5t-112 41.5t-43 108.5zM129 0v1090h283v-1090h-283z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "j",
    horizAdvX: 532,
    d: "M-68 -223q24 -2 45 -2q59 0 91 17q44 23 51 85q4 58 4 94v1119h280v-1115q0 -57 -4 -131q-11 -135 -96 -204.5t-266 -69.5q-59 0 -105 6v201zM109 1346q0 149 155 149q75 0 114.5 -38t39.5 -111t-39.5 -111.5t-114.5 -38.5q-155 0 -155 150z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "k",
    horizAdvX: 1193,
    d: "M129 0v1505h283v-913l438 498h340l-483 -506l489 -584h-356l-338 430l-90 -98v-332h-283z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "l",
    horizAdvX: 571,
    d: "M121 350v1155h282v-1149q0 -56 3 -100q4 -44 30 -58q20 -11 68 -11q13 0 28 1v-194q-73 -8 -174 -8q-109 0 -169 45t-64 147q-4 49 -4 172z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "m",
    horizAdvX: 1875,
    d: "M129 0v1090h283v-166l80 131q89 63 231 63q128 0 214 -56.5t120 -150.5l106 144q89 63 234 63q149 0 239.5 -75.5t110.5 -194.5q10 -69 10 -199v-649h-282v567q0 95 -9 178q-22 175 -184 175q-199 0 -199 -361v-559h-280v567q0 105 -8 178q-11 85 -58.5 130t-128.5 45 q-196 0 -196 -361v-559h-283z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "n",
    horizAdvX: 1271,
    d: "M129 0v1090h283v-177l84 129q108 76 262 76q171 0 270 -80t117 -225q8 -73 8 -199v-614h-283v575q0 97 -4 152q-6 90 -58 141.5t-151 51.5q-110 0 -177.5 -103t-67.5 -319v-498h-283z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "o",
    horizAdvX: 1241,
    d: "M55 545q0 167 65 295.5t194.5 203t306.5 74.5q265 0 415 -159t150 -414q0 -254 -150 -414t-415 -160t-415.5 160t-150.5 414zM348 545q0 -175 73 -275t200 -100t199.5 100t72.5 275q0 177 -72 276t-200 99t-200.5 -99t-72.5 -276z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "p",
    horizAdvX: 1316,
    d: "M129 -401v1491h283v-166l82 118q45 36 121 56t161 20q225 0 355.5 -153.5t130.5 -399.5q0 -143 -42 -258t-114.5 -187t-166 -110.5t-200.5 -38.5q-70 0 -143 17t-113 45l-71 112v-546h-283zM412 506q0 -89 23.5 -156.5t63.5 -105t86.5 -56t98.5 -18.5q128 0 206.5 97 t78.5 280q0 168 -75 270.5t-200 102.5q-127 0 -204.5 -87.5t-77.5 -275.5v-51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "q",
    horizAdvX: 1320,
    d: "M55 524q0 144 42 259t114.5 187t166 110t200.5 38q71 0 143.5 -16.5t112.5 -44.5l71 -113v146h283v-1491h-283v569l-82 -121q-46 -35 -122 -55.5t-160 -20.5q-225 0 -355.5 153.5t-130.5 399.5zM348 543q0 -168 75 -270.5t200 -102.5q127 0 204.5 87t77.5 275v54 q0 88 -23.5 155t-63.5 105t-86.5 56t-98.5 18q-128 0 -206.5 -97t-78.5 -280z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "r",
    horizAdvX: 778,
    d: "M129 0v1090h283v-199l86 151q80 74 186 74q47 0 80 -8v-227q-22 1 -42 1q-148 0 -224 -78q-86 -88 -86 -304v-500h-283z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "s",
    horizAdvX: 1017,
    d: "M43 332h283q17 -86 71 -130t131 -44q71 0 115.5 30t44.5 88q0 63 -59 103.5t-201 75.5q-165 42 -253.5 118t-88.5 209q0 156 117.5 246t314.5 90q189 0 301 -94.5t131 -249.5h-282q-14 76 -56.5 117t-111.5 41q-61 0 -95 -32t-34 -85q0 -61 55.5 -98.5t191.5 -71.5 q178 -46 266.5 -125t88.5 -223q0 -106 -61 -181t-160.5 -110t-227.5 -35q-204 0 -331 90.5t-150 270.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "t",
    horizAdvX: 739,
    d: "M25 895v186h159v269h283v-269h225v-186h-225v-504q0 -67 2 -96q7 -80 47 -104q29 -17 99 -17q26 0 59 2v-184q-94 -15 -187 -15q-155 0 -222.5 53t-76.5 171q-4 49 -4 157v537h-159z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "u",
    horizAdvX: 1265,
    d: "M111 446v644h282v-584q0 -77 8 -150q23 -184 211 -184q110 0 175 92t65 271v555h283v-1090h-283v184l-84 -139q-112 -74 -262 -74q-162 0 -263.5 79t-121.5 198q-10 69 -10 198z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "v",
    horizAdvX: 1159,
    d: "M0 1090h313l275 -877l268 877h305l-422 -1090h-315z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "w",
    horizAdvX: 1701,
    d: "M0 1090h315l193 -854l178 849h340l184 -847l191 852h303l-346 -1090h-320l-184 829l-186 -829h-322z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "x",
    horizAdvX: 1107,
    d: "M-6 0l385 553l-371 537h330l217 -363l215 363h326l-377 -539l381 -551h-330l-223 377l-230 -377h-323z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "y",
    horizAdvX: 1157,
    d: "M0 1090h315l271 -875l266 875h309l-438 -1131q-85 -219 -186 -304t-269 -85q-72 0 -127 8v195q29 -4 84 -4q75 0 123.5 33t81.5 112l14 35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "z",
    horizAdvX: 1017,
    d: "M57 0v178l590 715h-553v188h856v-186l-585 -707h593v-188h-901z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "{",
    horizAdvX: 763,
    d: "M186 637v160q93 7 130.5 42t37.5 93q0 66 -20 203q-25 174 -25 235q0 122 66.5 174.5t212.5 52.5h67v-159h-37q-82 0 -112.5 -19.5t-30.5 -70.5q0 -38 23 -193q24 -173 24 -229q0 -170 -172 -205q172 -38 172 -213q0 -56 -24 -229q-23 -152 -23 -193q0 -51 30.5 -70.5 t112.5 -19.5h37v-160h-67q-146 0 -212.5 53.5t-66.5 176.5q0 59 25 233q20 137 20 203q0 58 -37.5 93t-130.5 42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "|",
    horizAdvX: 581,
    d: "M199 -410v2048h184v-2048h-184z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "}",
    horizAdvX: 763,
    d: "M109 -4h36q82 0 113 19.5t31 70.5q0 41 -23 193q-24 173 -24 229q0 170 172 205q-84 19 -128 73.5t-44 139.5q0 56 24 229q23 155 23 193q0 51 -31 70.5t-113 19.5h-36v159h67q146 0 212.5 -52.5t66.5 -174.5q0 -61 -25 -235q-20 -137 -20 -203q0 -58 37.5 -93t130.5 -42 v-160q-93 -7 -130.5 -42t-37.5 -93q0 -66 20 -203q25 -174 25 -233q0 -123 -66.5 -176.5t-212.5 -53.5h-67v160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "~",
    d: "M170 457q0 329 250 329q41 0 82.5 -11.5t72 -25.5t93.5 -47q71 -39 111.5 -55t76.5 -16q52 0 74 36t22 119h160q0 -329 -250 -329q-59 0 -108.5 18t-141.5 66q-76 40 -115 55.5t-73 15.5q-52 0 -73 -38t-21 -117h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA1",
    horizAdvX: 538,
    d: "M109 954q0 70 45 115t114 45q71 0 116.5 -45t45.5 -115t-45.5 -114.5t-116.5 -44.5q-69 0 -114 44.5t-45 114.5zM131 -328l25 1012h227l25 -1012h-277z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA2",
    horizAdvX: 1261,
    d: "M117 535q0 240 124.5 389.5t323.5 181.5v164h166v-160q187 -18 300.5 -132.5t127.5 -285.5h-256q-14 87 -59.5 140t-112.5 73v-723q61 19 105 69t61 126h260q-30 -173 -142.5 -275.5t-283.5 -124.5v-161h-166v159q-202 22 -325 168.5t-123 391.5zM387 553q0 -152 49 -244 t129 -123v713q-81 -33 -129.5 -119.5t-48.5 -226.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA3",
    d: "M133 0v197q213 44 213 247q0 82 -35 174h-159v150h94q-56 124 -56 242q0 197 134 314.5t346 117.5q114 0 203 -33t145.5 -91.5t87.5 -132t37 -161.5h-287q-22 207 -188 207q-82 0 -129 -56.5t-47 -136.5q0 -68 14 -123.5t53 -146.5h416v-150h-361q21 -74 21 -137 q0 -177 -176 -258h694v-223h-1020z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA4",
    d: "M219 299l115 115q-62 91 -62 202t62 205l-115 115l103 100l114 -112q89 61 205 61t205 -61l115 112l100 -100l-113 -115q62 -91 62 -205q0 -110 -62 -204l113 -113l-100 -102l-113 112q-92 -61 -207 -61t-207 61l-112 -110zM446 616q0 -93 54 -150.5t141 -57.5 q85 0 139 57.5t54 150.5t-54 151t-139 58q-87 0 -141 -58t-54 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA5",
    d: "M49 1413h307l293 -643l287 643h297l-363 -655h230v-160h-318l-2 -2v-121h320v-160h-320v-315h-280v315h-320v160h320v123h-320v160h232z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA6",
    horizAdvX: 563,
    d: "M199 -328v697h166v-697h-166zM199 717v696h166v-696h-166z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA7",
    horizAdvX: 1226,
    d: "M55 604q0 102 46 179t130 124q-49 74 -49 164q0 167 119.5 269t312.5 102q189 0 299 -95.5t131 -259.5h-282q-31 168 -160 168q-57 0 -94 -37.5t-37 -101.5q0 -84 56 -132t206 -89q231 -62 336 -157t105 -249q0 -98 -49.5 -174t-135.5 -122q62 -80 62 -195 q0 -111 -62 -192.5t-163.5 -121.5t-227.5 -40q-202 0 -331 91.5t-150 270.5h282q21 -86 76.5 -131t130.5 -45q69 0 112.5 37t43.5 104q0 80 -66 135t-245 107q-195 55 -295.5 145.5t-100.5 245.5zM342 614q0 -71 61.5 -121t180.5 -83q142 -43 215 -78q40 17 63 52t23 79 q0 79 -60.5 129.5t-203.5 93.5q-109 30 -199 72q-80 -34 -80 -144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA8",
    horizAdvX: 614,
    d: "M0 1303q0 55 35.5 89.5t91.5 34.5t91.5 -34.5t35.5 -89.5t-35.5 -90t-91.5 -35t-91.5 35t-35.5 90zM360 1303q0 55 35.5 89.5t91.5 34.5t91.5 -34.5t35.5 -89.5t-35.5 -90t-91.5 -35t-91.5 35t-35.5 90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA9",
    horizAdvX: 1740,
    d: "M51 727q0 173 62 324.5t170.5 258.5t260.5 168.5t326 61.5t326.5 -61.5t260.5 -168.5t170.5 -258.5t62.5 -324.5t-62.5 -324.5t-170.5 -258.5t-260.5 -168.5t-326.5 -61.5t-326 61.5t-260.5 168.5t-170.5 258.5t-62 324.5zM229 727q0 -185 83 -333.5t229.5 -232 t328.5 -83.5t328.5 83.5t229.5 232t83 333.5t-83 334t-229.5 233t-328.5 84t-328.5 -84t-229.5 -233t-83 -334zM428 725q0 215 125.5 343t333.5 128q180 0 289 -97t131 -263h-250q-23 182 -178 182q-94 0 -141.5 -76t-47.5 -213q0 -143 51.5 -219t143.5 -76q69 0 115 47.5 t55 134.5h250q-30 -168 -139.5 -264t-295.5 -96q-198 0 -320 127t-122 342z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAB",
    horizAdvX: 1298,
    d: "M276 508l281 340h213l-281 -340l281 -340h-213zM702 508l281 340h213l-281 -340l281 -340h-213z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAC",
    d: "M227 643v160h805v-416h-166v256h-639z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAD",
    horizAdvX: 606,
    d: "M66 500v159h475v-159h-475z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAE",
    horizAdvX: 1015,
    d: "M78 1135q0 189 120 309.5t310 120.5t310 -120.5t120 -309.5t-120 -309.5t-310 -120.5t-310 120.5t-120 309.5zM190 1135q0 -142 89 -233t229 -91q139 0 228 90.5t89 233.5t-89 234t-228 91t-228.5 -91t-89.5 -234zM348 930v428h152q37 0 55 -2q67 -6 103 -37t36 -82 q0 -79 -84 -104q55 -13 62 -93q7 -67 26 -110h-127q-8 31 -14 88q-9 53 -59 53h-37v-141h-113zM461 1161h28q27 0 41 2q41 9 41 54q0 44 -41 51q-14 2 -38 2h-31v-109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAF",
    horizAdvX: 614,
    d: "M27 1217v155h561v-155h-561z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB0",
    horizAdvX: 634,
    d: "M49 1180q0 117 74.5 189.5t193.5 72.5t195 -73t76 -189q0 -115 -76 -188.5t-195 -73.5q-118 0 -193 73t-75 189zM211 1180q0 -48 31 -79.5t75 -31.5q45 0 76 31t31 80t-31 79.5t-76 30.5q-44 0 -75 -31t-31 -79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB1",
    d: "M221 0v152h838v-152h-838zM221 571v160h336v324h166v-324h336v-160h-336v-327h-166v327h-336z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB4",
    horizAdvX: 614,
    d: "M215 1178l160 241h254l-254 -241h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB6",
    horizAdvX: 1218,
    d: "M84 1034q0 153 85.5 260.5t236.5 116.5q35 2 114 2h565v-1638h-165v1478h-213v-1478h-166v880h-21q-79 0 -114 2q-151 9 -236.5 116.5t-85.5 260.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB7",
    horizAdvX: 501,
    d: "M74 625q0 77 50 126.5t126 49.5q77 0 127.5 -50t50.5 -126t-50.5 -126t-127.5 -50q-76 0 -126 49.5t-50 126.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB8",
    horizAdvX: 614,
    d: "M104 -295q53 -18 113 -18q125 0 125 69q0 43 -45 61t-152 11l97 190h147l-53 -102q182 -21 182 -164q0 -92 -83.5 -137t-221.5 -45q-63 0 -109 14v121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBB",
    horizAdvX: 1261,
    d: "M102 168l281 340l-281 340h213l281 -340l-281 -340h-213zM528 168l281 340l-281 340h213l281 -340l-281 -340h-213z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBF",
    horizAdvX: 1081,
    d: "M115 35q0 112 51.5 201.5t165.5 191.5q86 77 117.5 130t37.5 130h244q-4 -106 -36 -176t-109 -156q-97 -106 -133.5 -171t-36.5 -134q0 -92 47 -142t137 -50q91 0 144.5 61t60.5 180h285q-6 -210 -143 -331t-365 -121q-220 0 -343.5 105t-123.5 282zM449 958 q0 71 44.5 115.5t114.5 44.5t115 -45t45 -115q0 -69 -45 -114t-115 -45t-114.5 45t-44.5 114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC0",
    horizAdvX: 1384,
    d: "M31 0l510 1413h354l500 -1413h-308l-139 426h-475l-141 -426h-301zM410 1735h254l151 -230h-160zM545 649h332l-164 522z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC1",
    horizAdvX: 1384,
    d: "M31 0l510 1413h354l500 -1413h-308l-139 426h-475l-141 -426h-301zM545 649h332l-164 522zM625 1505l153 230h254l-248 -230h-159z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC2",
    horizAdvX: 1384,
    d: "M31 0l510 1413h354l500 -1413h-308l-139 426h-475l-141 -426h-301zM475 1505l131 230h223l132 -230h-179l-67 137l-64 -137h-176zM545 649h332l-164 522z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC3",
    horizAdvX: 1384,
    d: "M31 0l510 1413h354l500 -1413h-308l-139 426h-475l-141 -426h-301zM434 1528q0 114 37 164.5t113 50.5q68 0 149 -33q66 -27 92 -27q31 0 31 54h143q0 -116 -36 -166.5t-113 -50.5q-63 0 -150 32q-71 29 -92 29q-30 0 -30 -53h-144zM545 649h332l-164 522z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC4",
    horizAdvX: 1384,
    d: "M31 0l510 1413h354l500 -1413h-308l-139 426h-475l-141 -426h-301zM414 1618q0 55 35.5 89t91.5 34t90.5 -34t34.5 -89q0 -56 -35 -90.5t-90 -34.5q-56 0 -91.5 35t-35.5 90zM545 649h332l-164 522zM768 1618q0 55 35.5 89t91.5 34t90.5 -34t34.5 -89q0 -56 -35 -90.5 t-90 -34.5q-56 0 -91.5 35t-35.5 90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC5",
    horizAdvX: 1384,
    d: "M31 0l510 1413h354l500 -1413h-308l-139 426h-475l-141 -426h-301zM500 1665q0 83 61 136.5t156 53.5t156 -53.5t61 -136.5q0 -85 -61 -138.5t-156 -53.5t-156 53.5t-61 138.5zM545 649h332l-164 522zM639 1665q0 -37 22 -60.5t56 -23.5t56 23.5t22 60.5q0 36 -22 59 t-56 23t-56 -23t-22 -59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC6",
    horizAdvX: 1957,
    d: "M-80 0l772 1413h1186v-221h-764l33 -373h682v-223h-662l33 -373h698v-223h-958l-41 461h-440l-238 -461h-301zM573 682h306l-45 504z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC7",
    horizAdvX: 1470,
    d: "M104 698q0 170 52 311t143.5 235.5t217 146t271.5 51.5q276 0 432 -134t179 -354l2 -20h-283l-4 20q-27 134 -109.5 205.5t-220.5 71.5q-172 0 -276.5 -138.5t-104.5 -377.5q0 -256 104.5 -394.5t272.5 -138.5q134 0 216.5 75.5t111.5 211.5l4 20h281l-2 -20 q-24 -221 -179 -355t-409 -143l-29 -55q182 -21 182 -164q0 -92 -83.5 -137t-221.5 -45q-62 0 -108 14v121q53 -18 112 -18q125 0 125 69q0 43 -45 61t-151 11l75 152q-254 34 -404.5 225t-150.5 493z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC8",
    horizAdvX: 1261,
    d: "M182 0v1413h1000v-221h-717v-373h665v-223h-665v-373h737v-223h-1020zM385 1735h254l152 -230h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC9",
    horizAdvX: 1261,
    d: "M182 0v1413h1000v-221h-717v-373h665v-223h-665v-373h737v-223h-1020zM600 1505l154 230h254l-248 -230h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCA",
    horizAdvX: 1261,
    d: "M182 0v1413h1000v-221h-717v-373h665v-223h-665v-373h737v-223h-1020zM451 1505l131 230h223l131 -230h-178l-68 137l-63 -137h-176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCB",
    horizAdvX: 1261,
    d: "M182 0v1413h1000v-221h-717v-373h665v-223h-665v-373h737v-223h-1020zM389 1618q0 55 35.5 89t91.5 34t90.5 -34t34.5 -89q0 -56 -34.5 -90.5t-90.5 -34.5t-91.5 35t-35.5 90zM743 1618q0 55 35.5 89t91.5 34t90.5 -34t34.5 -89q0 -56 -34.5 -90.5t-90.5 -34.5t-91.5 35 t-35.5 90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCC",
    horizAdvX: 598,
    d: "M16 1735h254l152 -230h-160zM182 0v1413h283v-1413h-283z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCD",
    horizAdvX: 598,
    d: "M182 0v1413h283v-1413h-283zM231 1505l154 230h254l-248 -230h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCE",
    horizAdvX: 598,
    d: "M82 1505l131 230h223l131 -230h-178l-67 137l-64 -137h-176zM182 0v1413h283v-1413h-283z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCF",
    horizAdvX: 598,
    d: "M20 1618q0 55 35.5 89t91.5 34t90.5 -34t34.5 -89q0 -56 -35 -90.5t-90 -34.5q-56 0 -91.5 35t-35.5 90zM182 0v1413h283v-1413h-283zM375 1618q0 55 35.5 89t91.5 34t90.5 -34t34.5 -89q0 -56 -34.5 -90.5t-90.5 -34.5t-91.5 35t-35.5 90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD0",
    horizAdvX: 1501,
    d: "M66 610v160h120v643h488q108 0 180 -8q126 -15 229.5 -62.5t183 -129t123.5 -206t44 -282.5t-45 -288t-124.5 -218.5t-185 -142t-229.5 -68.5q-72 -8 -180 -8h-484v610h-120zM469 223h168q104 0 149 6q160 21 255.5 150t95.5 342q0 205 -91.5 323.5t-252.5 139.5 q-63 8 -152 8h-172v-422h240v-160h-240v-387z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD1",
    horizAdvX: 1556,
    d: "M182 0v1413h375l594 -1094q-10 190 -10 445v649h280l2 -1413h-387l-581 1073q10 -193 10 -434v-639h-283zM514 1528q0 114 37 164.5t113 50.5q68 0 149 -33q66 -27 92 -27q31 0 31 54h143q0 -116 -36 -166.5t-113 -50.5q-63 0 -150 32q-71 29 -92 29q-31 0 -31 -53h-143z "
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD2",
    horizAdvX: 1566,
    d: "M104 707q0 221 83 387t242 257t374 91q323 0 510.5 -200t187.5 -535q0 -334 -187.5 -535t-510.5 -201q-324 0 -511.5 200.5t-187.5 535.5zM399 707q0 -247 107.5 -386t296.5 -139q188 0 294.5 139t106.5 386q0 248 -106.5 386t-294.5 138q-190 0 -297 -138t-107 -386z M496 1735h254l151 -230h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD3",
    horizAdvX: 1566,
    d: "M104 707q0 221 83 387t242 257t374 91q323 0 510.5 -200t187.5 -535q0 -334 -187.5 -535t-510.5 -201q-324 0 -511.5 200.5t-187.5 535.5zM399 707q0 -247 107.5 -386t296.5 -139q188 0 294.5 139t106.5 386q0 248 -106.5 386t-294.5 138q-190 0 -297 -138t-107 -386z M711 1505l153 230h254l-248 -230h-159z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD4",
    horizAdvX: 1566,
    d: "M104 707q0 221 83 387t242 257t374 91q323 0 510.5 -200t187.5 -535q0 -334 -187.5 -535t-510.5 -201q-324 0 -511.5 200.5t-187.5 535.5zM399 707q0 -247 107.5 -386t296.5 -139q188 0 294.5 139t106.5 386q0 248 -106.5 386t-294.5 138q-190 0 -297 -138t-107 -386z M561 1505l131 230h223l132 -230h-179l-67 137l-64 -137h-176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD5",
    horizAdvX: 1566,
    d: "M104 707q0 221 83 387t242 257t374 91q323 0 510.5 -200t187.5 -535q0 -334 -187.5 -535t-510.5 -201q-324 0 -511.5 200.5t-187.5 535.5zM399 707q0 -247 107.5 -386t296.5 -139q188 0 294.5 139t106.5 386q0 248 -106.5 386t-294.5 138q-190 0 -297 -138t-107 -386z M520 1528q0 114 37 164.5t113 50.5q68 0 149 -33q66 -27 92 -27q31 0 31 54h143q0 -116 -36 -166.5t-113 -50.5q-63 0 -150 32q-71 29 -92 29q-30 0 -30 -53h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD6",
    horizAdvX: 1566,
    d: "M104 707q0 221 83 387t242 257t374 91q323 0 510.5 -200t187.5 -535q0 -334 -187.5 -535t-510.5 -201q-324 0 -511.5 200.5t-187.5 535.5zM399 707q0 -247 107.5 -386t296.5 -139q188 0 294.5 139t106.5 386q0 248 -106.5 386t-294.5 138q-190 0 -297 -138t-107 -386z M500 1618q0 55 35.5 89t91.5 34t90.5 -34t34.5 -89q0 -56 -35 -90.5t-90 -34.5q-56 0 -91.5 35t-35.5 90zM854 1618q0 55 35.5 89t91.5 34t90.5 -34t34.5 -89q0 -56 -35 -90.5t-90 -34.5q-56 0 -91.5 35t-35.5 90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD7",
    d: "M223 358l301 301l-301 302l117 116l301 -301l299 301l117 -116l-301 -302l301 -301l-117 -114l-299 301l-301 -301z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD8",
    horizAdvX: 1576,
    d: "M96 113l137 137q-124 183 -124 457q0 336 187 535.5t511 199.5q281 0 465 -154l129 129l117 -117l-138 -137q125 -184 125 -456q0 -335 -187 -535.5t-511 -200.5q-280 0 -463 156l-131 -131zM406 707q0 -147 36 -248l650 649q-108 123 -285 123q-188 0 -294.5 -138 t-106.5 -386zM524 307q104 -125 283 -125q189 0 296 139t107 386q0 148 -36 249z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD9",
    horizAdvX: 1437,
    d: "M164 575v838h280v-866q0 -64 5 -103q9 -124 85 -193t214 -69q137 0 212 69t84 193q5 39 5 103v866h280v-838q0 -99 -4 -165q-7 -92 -43 -169t-103 -138.5t-177.5 -96.5t-253.5 -35q-144 0 -254.5 35t-178.5 96.5t-104 138.5t-43 169q-4 66 -4 165zM440 1735h254l152 -230 h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDA",
    horizAdvX: 1437,
    d: "M164 575v838h280v-866q0 -64 5 -103q9 -124 85 -193t214 -69q137 0 212 69t84 193q5 39 5 103v866h280v-838q0 -99 -4 -165q-7 -92 -43 -169t-103 -138.5t-177.5 -96.5t-253.5 -35q-144 0 -254.5 35t-178.5 96.5t-104 138.5t-43 169q-4 66 -4 165zM655 1505l154 230h254 l-248 -230h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDB",
    horizAdvX: 1437,
    d: "M164 575v838h280v-866q0 -64 5 -103q9 -124 85 -193t214 -69q137 0 212 69t84 193q5 39 5 103v866h280v-838q0 -99 -4 -165q-7 -92 -43 -169t-103 -138.5t-177.5 -96.5t-253.5 -35q-144 0 -254.5 35t-178.5 96.5t-104 138.5t-43 169q-4 66 -4 165zM506 1505l131 230h223 l131 -230h-178l-68 137l-63 -137h-176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDC",
    horizAdvX: 1437,
    d: "M164 575v838h280v-866q0 -64 5 -103q9 -124 85 -193t214 -69q137 0 212 69t84 193q5 39 5 103v866h280v-838q0 -99 -4 -165q-7 -92 -43 -169t-103 -138.5t-177.5 -96.5t-253.5 -35q-144 0 -254.5 35t-178.5 96.5t-104 138.5t-43 169q-4 66 -4 165zM444 1618q0 55 35.5 89 t91.5 34t90.5 -34t34.5 -89q0 -56 -35 -90.5t-90 -34.5q-56 0 -91.5 35t-35.5 90zM799 1618q0 55 35.5 89t91.5 34t90.5 -34t34.5 -89q0 -56 -34.5 -90.5t-90.5 -34.5t-91.5 35t-35.5 90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDD",
    horizAdvX: 1282,
    d: "M33 1413h319l330 -616l319 616h312l-500 -866v-547h-281v547zM582 1505l153 230h254l-248 -230h-159z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDE",
    horizAdvX: 1316,
    d: "M182 0v1413h283v-180h223q116 0 203 -10q163 -20 264.5 -124t101.5 -286t-101.5 -287.5t-264.5 -126.5q-70 -8 -203 -8h-223v-391h-283zM465 614h201q67 0 125 7q170 25 170 190q0 87 -46 134.5t-124 58.5q-49 6 -125 6h-201v-396z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDF",
    horizAdvX: 1310,
    d: "M129 0v928q0 102 4 176q13 211 154 325.5t372 114.5q233 0 367.5 -104t134.5 -275q0 -105 -57 -190q-69 -38 -101 -76.5t-32 -83.5q0 -46 26 -86t88 -98q89 -85 124.5 -152.5t35.5 -175.5q0 -99 -56.5 -171t-145.5 -106t-197 -34q-146 0 -246 20v215q102 -26 193 -26 q75 0 113 35t38 98q0 48 -23.5 92t-84.5 100q-93 90 -128.5 148t-35.5 141q0 152 157 238q33 49 33 108q0 81 -54 126.5t-159 45.5q-103 0 -164.5 -60t-68.5 -173q-4 -58 -4 -156v-944h-283z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE0",
    horizAdvX: 1150,
    d: "M68 289q0 181 153 278t447 97h69v22q0 65 -4 102q-6 61 -47.5 96.5t-120.5 35.5q-84 0 -130 -47.5t-52 -137.5l-274 -2q6 180 136 282.5t330 102.5q410 0 437 -321q6 -77 6 -168v-353q0 -125 20 -276h-276l-21 160l-53 -117q-107 -72 -270 -72q-148 0 -249 84.5 t-101 233.5zM268 1419h254l158 -241h-160zM360 311q0 -70 44.5 -105.5t121.5 -35.5q91 0 151 60.5t60 170.5v88q-115 8 -198 -7t-131 -58t-48 -113z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE1",
    horizAdvX: 1150,
    d: "M68 289q0 181 153 278t447 97h69v22q0 65 -4 102q-6 61 -47.5 96.5t-120.5 35.5q-84 0 -130 -47.5t-52 -137.5l-274 -2q6 180 136 282.5t330 102.5q410 0 437 -321q6 -77 6 -168v-353q0 -125 20 -276h-276l-21 160l-53 -117q-107 -72 -270 -72q-148 0 -249 84.5 t-101 233.5zM360 311q0 -70 44.5 -105.5t121.5 -35.5q91 0 151 60.5t60 170.5v88q-115 8 -198 -7t-131 -58t-48 -113zM481 1178l160 241h254l-254 -241h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE2",
    horizAdvX: 1150,
    d: "M68 289q0 181 153 278t447 97h69v22q0 65 -4 102q-6 61 -47.5 96.5t-120.5 35.5q-84 0 -130 -47.5t-52 -137.5l-274 -2q6 180 136 282.5t330 102.5q410 0 437 -321q6 -77 6 -168v-353q0 -125 20 -276h-276l-21 160l-53 -117q-107 -72 -270 -72q-148 0 -249 84.5 t-101 233.5zM332 1178l131 241h223l131 -241h-176l-68 141l-67 -141h-174zM360 311q0 -70 44.5 -105.5t121.5 -35.5q91 0 151 60.5t60 170.5v88q-115 8 -198 -7t-131 -58t-48 -113z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE3",
    horizAdvX: 1150,
    d: "M68 289q0 181 153 278t447 97h69v22q0 65 -4 102q-6 61 -47.5 96.5t-120.5 35.5q-84 0 -130 -47.5t-52 -137.5l-274 -2q6 180 136 282.5t330 102.5q410 0 437 -321q6 -77 6 -168v-353q0 -125 20 -276h-276l-21 160l-53 -117q-107 -72 -270 -72q-148 0 -249 84.5 t-101 233.5zM291 1200q0 114 37 164.5t112 50.5q69 0 150 -33q64 -26 92 -26q31 0 31 53h143q0 -115 -36.5 -166t-112.5 -51q-62 0 -150 35q-71 26 -92 26q-31 0 -31 -53h-143zM360 311q0 -70 44.5 -105.5t121.5 -35.5q91 0 151 60.5t60 170.5v88q-115 8 -198 -7t-131 -58 t-48 -113z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE4",
    horizAdvX: 1150,
    d: "M68 289q0 181 153 278t447 97h69v22q0 65 -4 102q-6 61 -47.5 96.5t-120.5 35.5q-84 0 -130 -47.5t-52 -137.5l-274 -2q6 180 136 282.5t330 102.5q410 0 437 -321q6 -77 6 -168v-353q0 -125 20 -276h-276l-21 160l-53 -117q-107 -72 -270 -72q-148 0 -249 84.5 t-101 233.5zM266 1303q0 55 35.5 89.5t91.5 34.5t91.5 -34.5t35.5 -89.5t-35.5 -90t-91.5 -35t-91.5 35t-35.5 90zM360 311q0 -70 44.5 -105.5t121.5 -35.5q91 0 151 60.5t60 170.5v88q-115 8 -198 -7t-131 -58t-48 -113zM627 1303q0 55 35.5 89.5t91.5 34.5t91.5 -34.5 t35.5 -89.5t-35.5 -90t-91.5 -35t-91.5 35t-35.5 90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE5",
    horizAdvX: 1150,
    d: "M68 289q0 181 153 278t447 97h69v22q0 65 -4 102q-6 61 -47.5 96.5t-120.5 35.5q-84 0 -130 -47.5t-52 -137.5l-274 -2q6 180 136 282.5t330 102.5q410 0 437 -321q6 -77 6 -168v-353q0 -125 20 -276h-276l-21 160l-53 -117q-107 -72 -270 -72q-148 0 -249 84.5 t-101 233.5zM356 1358q0 87 60.5 141.5t156.5 54.5t157 -54.5t61 -141.5q0 -88 -61.5 -143.5t-156.5 -55.5t-156 55.5t-61 143.5zM360 311q0 -70 44.5 -105.5t121.5 -35.5q91 0 151 60.5t60 170.5v88q-115 8 -198 -7t-131 -58t-48 -113zM496 1358q0 -42 21.5 -66t55.5 -24 q35 0 56.5 24t21.5 66t-21.5 66t-56.5 24q-34 0 -55.5 -24t-21.5 -66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE6",
    horizAdvX: 1914,
    d: "M68 295q0 182 157 271t451 89h96v33q0 232 -194 232q-88 0 -139.5 -48.5t-55.5 -138.5h-274q3 180 132 282.5t334 102.5q287 0 377 -190q131 190 400 190q157 0 272 -76.5t171 -200t56 -274.5q0 -59 -4 -96h-772q13 -158 79.5 -229.5t170.5 -71.5q91 0 151.5 48.5 t75.5 135.5h281q-39 -186 -177.5 -284.5t-336.5 -98.5q-305 0 -434 238l-101 -141q-125 -97 -315 -97q-180 0 -290.5 84.5t-110.5 239.5zM360 315q0 -145 181 -145q103 0 168 71t65 193v37q-213 9 -313.5 -25.5t-100.5 -130.5zM1081 655h480q-14 129 -73 197t-159 68 t-165 -67.5t-83 -197.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE7",
    horizAdvX: 1148,
    d: "M55 537q0 136 43 247.5t117.5 183.5t173 111t211.5 39q216 0 349.5 -118t148.5 -304h-279q-38 224 -225 224q-112 0 -179 -92.5t-67 -272.5q0 -194 66 -289.5t178 -95.5q84 0 142 53t79 154h283q-33 -185 -156.5 -288.5t-312.5 -115.5l-29 -57q182 -21 182 -164 q0 -92 -83.5 -137t-221.5 -45q-62 0 -108 14v121q53 -18 112 -18q125 0 125 69q0 43 -45 61t-151 11l75 149q-195 29 -311.5 172.5t-116.5 387.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE8",
    horizAdvX: 1183,
    d: "M55 541q0 253 152.5 415t400.5 162q122 0 220 -44t160.5 -120t96 -175t33.5 -212q0 -59 -4 -96h-774q24 -301 252 -301q92 0 153 48.5t74 135.5h283q-40 -186 -179 -284.5t-337 -98.5q-114 0 -209.5 36t-168 105t-113 179t-40.5 250zM291 1419h254l157 -241h-159z M348 655h479q-14 130 -72 197.5t-159 67.5t-165.5 -66.5t-82.5 -198.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE9",
    horizAdvX: 1183,
    d: "M55 541q0 253 152.5 415t400.5 162q122 0 220 -44t160.5 -120t96 -175t33.5 -212q0 -59 -4 -96h-774q24 -301 252 -301q92 0 153 48.5t74 135.5h283q-40 -186 -179 -284.5t-337 -98.5q-114 0 -209.5 36t-168 105t-113 179t-40.5 250zM348 655h479q-14 130 -72 197.5 t-159 67.5t-165.5 -66.5t-82.5 -198.5zM504 1178l160 241h254l-254 -241h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEA",
    horizAdvX: 1183,
    d: "M55 541q0 253 152.5 415t400.5 162q122 0 220 -44t160.5 -120t96 -175t33.5 -212q0 -59 -4 -96h-774q24 -301 252 -301q92 0 153 48.5t74 135.5h283q-40 -186 -179 -284.5t-337 -98.5q-114 0 -209.5 36t-168 105t-113 179t-40.5 250zM348 655h479q-14 130 -72 197.5 t-159 67.5t-165.5 -66.5t-82.5 -198.5zM354 1178l131 241h224l131 -241h-176l-68 141l-68 -141h-174z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEB",
    horizAdvX: 1183,
    d: "M55 541q0 253 152.5 415t400.5 162q122 0 220 -44t160.5 -120t96 -175t33.5 -212q0 -59 -4 -96h-774q24 -301 252 -301q92 0 153 48.5t74 135.5h283q-40 -186 -179 -284.5t-337 -98.5q-114 0 -209.5 36t-168 105t-113 179t-40.5 250zM289 1303q0 55 35.5 89.5t91.5 34.5 t91.5 -34.5t35.5 -89.5t-35.5 -90t-91.5 -35t-91.5 35t-35.5 90zM348 655h479q-14 130 -72 197.5t-159 67.5t-165.5 -66.5t-82.5 -198.5zM649 1303q0 55 35.5 89.5t91.5 34.5t91.5 -34.5t35.5 -89.5t-35.5 -90t-91.5 -35t-91.5 35t-35.5 90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEC",
    horizAdvX: 544,
    d: "M-35 1419h254l158 -241h-160zM129 0v1090h283v-1090h-283z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xED",
    horizAdvX: 544,
    d: "M129 0v1090h283v-1090h-283zM178 1178l160 241h254l-254 -241h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEE",
    horizAdvX: 544,
    d: "M29 1178l131 241h223l131 -241h-176l-68 141l-67 -141h-174zM129 0v1090h283v-1090h-283z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEF",
    horizAdvX: 544,
    d: "M-37 1303q0 55 35.5 89.5t91.5 34.5t91.5 -34.5t35.5 -89.5t-35.5 -90t-91.5 -35t-91.5 35t-35.5 90zM129 0v1090h283v-1090h-283zM324 1303q0 55 35.5 89.5t91.5 34.5t91.5 -34.5t35.5 -89.5t-35.5 -90t-91.5 -35t-91.5 35t-35.5 90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF0",
    horizAdvX: 1284,
    d: "M55 539q0 135 41.5 246t112.5 183t165 111t201 39q60 0 107.5 -13t103.5 -46l91 -117q-15 160 -113 275l-272 -74l-33 131l182 49q-66 42 -154 78l226 125q119 -51 211 -127l157 43l33 -129l-86 -25q166 -219 166 -659q0 -141 -32.5 -254.5t-86.5 -187.5t-128.5 -123.5 t-154 -71t-167.5 -21.5q-187 0 -317 74t-191.5 200t-61.5 294zM352 547q0 -179 71.5 -273t205.5 -94q127 0 198.5 92.5t71.5 259.5v60q0 151 -77.5 234t-192.5 83q-128 0 -202.5 -98.5t-74.5 -263.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF1",
    horizAdvX: 1271,
    d: "M129 0v1090h283v-177l84 129q108 76 262 76q171 0 270 -80t117 -225q8 -73 8 -199v-614h-283v575q0 97 -4 152q-6 90 -58 141.5t-151 51.5q-110 0 -177.5 -103t-67.5 -319v-498h-283zM360 1200q0 114 37 164.5t113 50.5q68 0 149 -33q64 -26 93 -26q30 0 30 53h144 q0 -115 -36.5 -166t-113.5 -51q-61 0 -149 35q-71 26 -92 26q-31 0 -31 -53h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF2",
    horizAdvX: 1241,
    d: "M55 545q0 167 65 295.5t194.5 203t306.5 74.5q265 0 415 -159t150 -414q0 -254 -150 -414t-415 -160t-415.5 160t-150.5 414zM315 1419h254l158 -241h-160zM348 545q0 -175 73 -275t200 -100t199.5 100t72.5 275q0 177 -72 276t-200 99t-200.5 -99t-72.5 -276z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF3",
    horizAdvX: 1241,
    d: "M55 545q0 167 65 295.5t194.5 203t306.5 74.5q265 0 415 -159t150 -414q0 -254 -150 -414t-415 -160t-415.5 160t-150.5 414zM348 545q0 -175 73 -275t200 -100t199.5 100t72.5 275q0 177 -72 276t-200 99t-200.5 -99t-72.5 -276zM528 1178l160 241h254l-254 -241h-160z "
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF4",
    horizAdvX: 1241,
    d: "M55 545q0 167 65 295.5t194.5 203t306.5 74.5q265 0 415 -159t150 -414q0 -254 -150 -414t-415 -160t-415.5 160t-150.5 414zM348 545q0 -175 73 -275t200 -100t199.5 100t72.5 275q0 177 -72 276t-200 99t-200.5 -99t-72.5 -276zM379 1178l131 241h223l131 -241h-176 l-67 141l-68 -141h-174z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF5",
    horizAdvX: 1241,
    d: "M55 545q0 167 65 295.5t194.5 203t306.5 74.5q265 0 415 -159t150 -414q0 -254 -150 -414t-415 -160t-415.5 160t-150.5 414zM338 1200q0 114 37 164.5t112 50.5q69 0 150 -33q64 -26 92 -26q31 0 31 53h143q0 -115 -36.5 -166t-112.5 -51q-62 0 -150 35q-71 26 -92 26 q-31 0 -31 -53h-143zM348 545q0 -175 73 -275t200 -100t199.5 100t72.5 275q0 177 -72 276t-200 99t-200.5 -99t-72.5 -276z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF6",
    horizAdvX: 1241,
    d: "M55 545q0 167 65 295.5t194.5 203t306.5 74.5q265 0 415 -159t150 -414q0 -254 -150 -414t-415 -160t-415.5 160t-150.5 414zM313 1303q0 55 35.5 89.5t91.5 34.5t91.5 -34.5t35.5 -89.5t-35.5 -90t-91.5 -35t-91.5 35t-35.5 90zM348 545q0 -175 73 -275t200 -100 t199.5 100t72.5 275q0 177 -72 276t-200 99t-200.5 -99t-72.5 -276zM674 1303q0 55 35.5 89.5t91.5 34.5t91.5 -34.5t35.5 -89.5t-35.5 -90t-91.5 -35t-91.5 35t-35.5 90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF7",
    d: "M170 571v160h940v-160h-940zM500 291q0 60 40.5 100.5t100.5 40.5q61 0 102 -40.5t41 -100.5q0 -62 -41 -103t-102 -41q-60 0 -100.5 41.5t-40.5 102.5zM500 1008q0 61 40.5 102t100.5 41q61 0 102 -40.5t41 -102.5q0 -60 -41 -101t-102 -41q-60 0 -100.5 41t-40.5 101z "
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF8",
    horizAdvX: 1290,
    d: "M47 63l125 125q-104 143 -104 357q0 255 150 414t415 159q218 0 360 -108l133 133l117 -117l-137 -137q92 -147 92 -344q0 -254 -150 -414t-415 -160q-200 0 -346 99l-123 -123zM360 545q0 -75 17 -152l444 445q-73 82 -188 82q-128 0 -200.5 -99t-72.5 -276zM457 240 q70 -70 176 -70q128 0 200 99.5t72 275.5q0 73 -12 131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF9",
    horizAdvX: 1265,
    d: "M111 446v644h282v-584q0 -77 8 -150q23 -184 211 -184q110 0 175 92t65 271v555h283v-1090h-283v184l-84 -139q-112 -74 -262 -74q-162 0 -263.5 79t-121.5 198q-10 69 -10 198zM317 1419h254l158 -241h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFA",
    horizAdvX: 1265,
    d: "M111 446v644h282v-584q0 -77 8 -150q23 -184 211 -184q110 0 175 92t65 271v555h283v-1090h-283v184l-84 -139q-112 -74 -262 -74q-162 0 -263.5 79t-121.5 198q-10 69 -10 198zM530 1178l160 241h254l-254 -241h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFB",
    horizAdvX: 1265,
    d: "M111 446v644h282v-584q0 -77 8 -150q23 -184 211 -184q110 0 175 92t65 271v555h283v-1090h-283v184l-84 -139q-112 -74 -262 -74q-162 0 -263.5 79t-121.5 198q-10 69 -10 198zM381 1178l131 241h223l131 -241h-176l-67 141l-68 -141h-174z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFC",
    horizAdvX: 1265,
    d: "M111 446v644h282v-584q0 -77 8 -150q23 -184 211 -184q110 0 175 92t65 271v555h283v-1090h-283v184l-84 -139q-112 -74 -262 -74q-162 0 -263.5 79t-121.5 198q-10 69 -10 198zM315 1303q0 55 35.5 89.5t91.5 34.5t91.5 -34.5t35.5 -89.5t-35.5 -90t-91.5 -35t-91.5 35 t-35.5 90zM676 1303q0 55 35.5 89.5t91.5 34.5t91.5 -34.5t35.5 -89.5t-35.5 -90t-91.5 -35t-91.5 35t-35.5 90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFD",
    horizAdvX: 1157,
    d: "M0 1090h315l271 -875l266 875h309l-438 -1131q-85 -219 -186 -304t-269 -85q-72 0 -127 8v195q29 -4 84 -4q75 0 123.5 33t81.5 112l14 35zM481 1178l160 241h254l-254 -241h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFE",
    horizAdvX: 1316,
    d: "M129 -401v1906h283v-581l82 118q45 36 121 56t161 20q225 0 355.5 -153.5t130.5 -399.5q0 -143 -42 -258t-114.5 -187t-166 -110.5t-200.5 -38.5q-70 0 -143 17t-113 45l-71 112v-546h-283zM412 506q0 -89 23.5 -156.5t63.5 -105t86.5 -56t98.5 -18.5q128 0 206.5 97 t78.5 280q0 168 -75 270.5t-200 102.5q-127 0 -204.5 -87.5t-77.5 -275.5v-51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFF",
    horizAdvX: 1157,
    d: "M0 1090h315l271 -875l266 875h309l-438 -1131q-85 -219 -186 -304t-269 -85q-72 0 -127 8v195q29 -4 84 -4q75 0 123.5 33t81.5 112l14 35zM266 1303q0 55 35.5 89.5t91.5 34.5t91.5 -34.5t35.5 -89.5t-35.5 -90t-91.5 -35t-91.5 35t-35.5 90zM627 1303q0 55 35.5 89.5 t91.5 34.5t91.5 -34.5t35.5 -89.5t-35.5 -90t-91.5 -35t-91.5 35t-35.5 90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0152",
    horizAdvX: 2283,
    d: "M104 707q0 215 81 382.5t228 260t335 92.5q145 0 231 -29t164 -104l61 -142v246h1000v-221h-717v-373h665v-223h-665v-373h737v-223h-1020v244l-61 -142q-77 -73 -167 -102t-228 -29q-188 0 -335 93t-228 260.5t-81 382.5zM399 707q0 -244 107.5 -384.5t296.5 -140.5 q187 0 294 140.5t107 384.5q0 245 -107 384.5t-294 139.5q-189 0 -296.5 -139.5t-107.5 -384.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0153",
    horizAdvX: 2021,
    d: "M55 545q0 167 65 295.5t194.5 203t306.5 74.5q289 0 421 -229q132 229 414 229q118 0 214 -44t158 -120t95 -175.5t33 -211.5q0 -59 -4 -96h-772q13 -158 79.5 -229.5t170.5 -71.5q92 0 153 48.5t74 135.5h282q-40 -185 -177.5 -284t-331.5 -99q-272 0 -398 219 q-128 -219 -411 -219q-265 0 -415.5 160t-150.5 414zM348 545q0 -175 73 -275t200 -100t199.5 100t72.5 275q0 177 -72 276t-200 99t-200.5 -99t-72.5 -276zM1188 655h477q-14 129 -72.5 197t-158.5 68t-163.5 -67.5t-82.5 -197.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0178",
    horizAdvX: 1282,
    d: "M33 1413h319l330 -616l319 616h312l-500 -866v-547h-281v547zM371 1618q0 55 35.5 89t91.5 34t90.5 -34t34.5 -89q0 -56 -34.5 -90.5t-90.5 -34.5t-91.5 35t-35.5 90zM725 1618q0 55 35.5 89t91.5 34t90.5 -34t34.5 -89q0 -56 -34.5 -90.5t-90.5 -34.5t-91.5 35t-35.5 90 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u02C6",
    horizAdvX: 614,
    d: "M66 1178l131 241h223l131 -241h-176l-68 141l-67 -141h-174z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u02DC",
    horizAdvX: 614,
    d: "M25 1200q0 114 37 164.5t112 50.5q69 0 150 -33q64 -26 92 -26q30 0 30 53h144q0 -115 -36.5 -166t-113.5 -51q-61 0 -149 35q-71 26 -92 26q-31 0 -31 -53h-143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2000",
    horizAdvX: 927
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2001",
    horizAdvX: 1855
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2002",
    horizAdvX: 927
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2003",
    horizAdvX: 1855
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2004",
    horizAdvX: 618
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2005",
    horizAdvX: 463
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2006",
    horizAdvX: 309
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2007",
    horizAdvX: 309
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2008",
    horizAdvX: 231
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2009",
    horizAdvX: 371
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u200A",
    horizAdvX: 103
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2010",
    horizAdvX: 606,
    d: "M66 500v159h475v-159h-475z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2011",
    horizAdvX: 606,
    d: "M66 500v159h475v-159h-475z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2012",
    horizAdvX: 606,
    d: "M66 500v159h475v-159h-475z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2013",
    horizAdvX: 1024,
    d: "M166 516v160h692v-160h-692z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2014",
    horizAdvX: 2048,
    d: "M166 516v160h1716v-160h-1716z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2018",
    horizAdvX: 589,
    d: "M115 942v21l209 542h227l-162 -563h-274z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2019",
    horizAdvX: 589,
    d: "M39 942l162 563h274v-20l-209 -543h-227z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201A",
    horizAdvX: 501,
    d: "M-57 -250l161 537h275v-21l-207 -516h-229z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201C",
    horizAdvX: 1017,
    d: "M115 942v21l209 542h227l-162 -563h-274zM543 942v21l209 542h227l-162 -563h-274z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201D",
    horizAdvX: 1017,
    d: "M39 942l162 563h274v-20l-209 -543h-227zM467 942l162 563h274v-20l-211 -543h-225z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201E",
    horizAdvX: 929,
    d: "M-57 -250l161 537h275v-21l-207 -516h-229zM369 -250l161 537h275v-21l-205 -516h-231z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2022",
    horizAdvX: 776,
    d: "M145 625q0 106 68.5 173.5t175.5 67.5q106 0 174 -67.5t68 -173.5t-68 -174t-174 -68q-107 0 -175.5 68t-68.5 174z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2026",
    horizAdvX: 1501,
    d: "M80 143q0 75 47.5 123.5t122.5 48.5q76 0 124 -48.5t48 -123.5t-48 -123.5t-124 -48.5q-75 0 -122.5 48.5t-47.5 123.5zM580 143q0 75 47.5 123.5t122.5 48.5q76 0 124 -48.5t48 -123.5t-48 -123.5t-124 -48.5q-75 0 -122.5 48.5t-47.5 123.5zM1079 143q0 75 47.5 123.5 t122.5 48.5q76 0 124 -48.5t48 -123.5t-48 -123.5t-124 -48.5q-75 0 -122.5 48.5t-47.5 123.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u202F",
    horizAdvX: 371
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2039",
    horizAdvX: 872,
    d: "M276 508l281 340h213l-281 -340l281 -340h-213z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u203A",
    horizAdvX: 833,
    d: "M102 168l281 340l-281 340h213l281 -340l-281 -340h-213z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u205F",
    horizAdvX: 463
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u20AC",
    d: "M70 492l30 159h115v49q0 40 2 58h-96l33 160h79q33 176 122 295t213.5 174t281.5 55q258 0 379 -127l-109 -178q-108 94 -262 94q-262 0 -323 -313h532l-35 -160h-516v-49v-58h496l-29 -159h-451q30 -166 113 -238t219 -72q167 0 301 82v-211q-77 -44 -157.5 -63 t-198.5 -19q-246 0 -394 123t-186 398h-159z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2122",
    horizAdvX: 1101,
    d: "M43 1264v88h412v-88h-148v-330h-114v330h-150zM504 934v416h172l78 -301l75 301h166v-416h-114l4 291l-76 -283h-117l-76 281l2 -289h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u25FC",
    horizAdvX: 1085,
    d: "M0 0v1085h1085v-1085h-1085z"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "U",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "U",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "U",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "U",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "U",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "U",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "U",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 176
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "u,ugrave,uacute,ucircumflex,udieresis",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "z",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "period,ellipsis",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "J",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla",
    g2: "T",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,uniFB02",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,uniFB02",
    g2: "v",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G",
    g2: "T",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G",
    g2: "Y,Yacute,Ydieresis",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,oe",
    g2: "x",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,oe",
    g2: "y,yacute,ydieresis",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "T",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "Y,Yacute,Ydieresis",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "V",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "W",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "Z",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "period,ellipsis",
    k: 127
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 117
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "T",
    k: 274
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "Y,Yacute,Ydieresis",
    k: 297
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "V",
    k: 217
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "W",
    k: 168
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "T",
    k: 147
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "v",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "Y,Yacute,Ydieresis",
    k: 182
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "y,yacute,ydieresis",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "V",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "W",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "t",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "quoteright,quotedblright",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "S",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "w",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 117
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "u,ugrave,uacute,ucircumflex,udieresis",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "m,n,p,r,ntilde",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "i,igrave,iacute,icircumflex,idieresis",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "b,h,k,thorn",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "J",
    k: 152
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn",
    g2: "x",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn",
    g2: "y,yacute,ydieresis",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 37
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAileronBoldWebfont);
export default __webpack_public_path__ + "static/media/aileron-bold-webfont.737c7528439d33550079d51f0293cee4.svg";
export { ForwardRef as ReactComponent };